import styled from "styled-components";

export const ResumeSectionWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  @media only screen and (max-width: 917px) {
    & {
      display: block;
    }
  }
`;

export const ResumeLeft = styled.div`
  width: 50%;
  height: 100%;
  display: flex;

  @media only screen and (max-width: 917px) {
    & {
      width: 100%;
    }
  }
`;

export const ResumeRight = styled.div`
  width: 50%;
  height: 100%;
  background: linear-gradient(
      to right,
      rgba(33, 34, 37, 0.7),
      rgba(33, 34, 37, 0.7)
    ),
    url("/images/resume-bg.jpg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  @media only screen and (max-width: 917px) {
    & {
      display: none;
    }
  }
`;

export const ResumeEducations = styled.div`
  width: 50%;
  height: 100%;
  padding: 2rem;

  & > h1 {
    font-family: "Aladin", cursive;
    margin-bottom: 4rem;
    color: #3fca89;
    align-self: flex-start;
    text-decoration: underline;
    font-size: 2rem;
  }
`;

export const ResumeExperiences = styled.div`
  width: 50%;
  height: 100%;
  padding: 2rem;

  & > h1 {
    font-family: "Aladin", cursive;
    margin-bottom: 4rem;
    color: #3fca89;
    align-self: flex-start;
    text-decoration: underline;
    font-size: 2rem;
  }
`;

export const ResumeCard = styled.div`
  margin-bottom: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 2rem;
  border-radius: 3px;

  & > h1 {
    font-size: 1.6rem;
    color: rgba(255, 255, 255, 0.5);
  }

  & > h4 {
    font-weight: 300;
    font-size: 1.2rem;
    color: rgba(255, 255, 255, 0.5);
  }

  & > p {
    font-size: 1.5rem;
    margin-top: 1.5rem;
  }
`;
